import gauge from 'assets/icons/icon-gauge.svg'
import merchant from 'assets/icons/icon-merchant.svg'
import warning from 'assets/icons/icon-warning.svg'
import checkBadge from 'assets/icons/icon-check-badge.svg'
import { dateUtilities } from 'utils/dateUtilities'
import { MetricObject } from '../metrics-config'
import { format } from 'date-fns'

const { getNextDays } = dateUtilities

export const formatGetNextDays = (days: number) => {
    const d = getNextDays(days)
    return {
        from: format(d.from, 'yyyy-MM-dd'),
        to: format(d.to, 'yyyy-MM-dd'),
    }
}

export const issuer_metrics: MetricObject = {
    chargebacks: {
        title: 'Cases',
        timeframe: '(This Month)',
        link: null,
        variant: 'default',
        icon: gauge,
    },
    caseFraudPercent: {
        title: 'Fraudulent Cases',
        timeframe: '(This Month)',
        link: null,
        variant: 'default',
        icon: warning,
    },
    caseNonFraudPercent: {
        title: 'Non Fraudulent Cases',
        timeframe: '(This Month)',
        link: null,
        variant: 'default',
        icon: checkBadge,
    },
    mids: {
        title: 'Account Numbers',
        timeframe: '(Total)',
        link: {
            to: '/account-settings',
            text: 'View More',
            filter_presets: [
                {
                    filter_name: 'mids_tile_clicked',
                    filter_value: null,
                },
            ],
        },
        variant: 'default',
        icon: merchant,
    },
}
